/* eslint-disable react/no-unused-state */
/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2019 Deere & Company

import './list-view-show-more.scss';
import * as busyCounter from '../action-creators/busy-counter';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { buildNumber } from '../services/build-number';
import { getStore } from '../../configmodules/store-reducer-config/store';
import { translate } from '../services/translation-service';

class ListViewShowMore extends Component {

    constructor(props) {

        super(props);
        this.state = {
            nextShow: this.props.showPerMore,
            shownItems: this.props.initialShowItems,
        };
        this.handleMore = this.handleMore.bind(this);
        this.handleAll = this.handleAll.bind(this);

    }

    componentWillReceiveProps(newProps) {

        if (this.props.totalItems !== newProps.totalItems) {

            this.setState({
                nextShow: newProps.showPerMore,
                shownItems: newProps.initialShowItems,
            });

        }

    }

    handleMore = (event) => {

        event.preventDefault();

        const { dispatch } = getStore();

        dispatch(busyCounter.increaseBusyCounter());
        setTimeout(() => this.setState((prevState) => {

            const nShow = Math.round(prevState.nextShow * this.props.perMoreMultiplier);

            return {
                nextShow: nShow,
                shownItems: prevState.shownItems + prevState.nextShow,
            };

        }, () => {

            dispatch(busyCounter.decreaseBusyCounter());

        }), 15);

    };

    handleAll = (event) => {

        event.preventDefault();

        const { dispatch } = getStore();

        dispatch(busyCounter.increaseBusyCounter());
        setTimeout(() => this.setState({ shownItems: this.props.totalItems }, () => {

            dispatch(busyCounter.decreaseBusyCounter());

        }), 15);

    };

    render() {

        return (
            <div>
                {

                    this.props.children.slice(0, this.state.shownItems)

                }
                {(this.props.totalItems > this.state.shownItems) && (
                    <footer className="show-more-footer">
                        <button
                            type="button"
                            className="button-primary"
                            onClick={this.handleMore}
                        >
                            {translate('SHOW_MORE')}
                        </button>
                        {this.props.showAllOption && (
                            <button
                                type="button"
                                className=""
                                onClick={this.handleAll}
                            >
                                {translate('SHOW_ALL', { count: buildNumber(this.props.children.length) })}
                            </button>
                        )}
                    </footer>
                )}
            </div>
        );

    }

}

ListViewShowMore.displayName = 'ListViewShowMore';
ListViewShowMore.propTypes = {
    children: PropTypes.node,
    initialShowItems: PropTypes.number,
    perMoreMultiplier: PropTypes.number,
    showAllOption: PropTypes.bool,
    showPerMore: PropTypes.number,
    totalItems: PropTypes.number.isRequired,
};

export default ListViewShowMore;
